(() => {
  // Prevent duplicate listeners if Shopify loads this section more than once.
  if (window.__conversionTableHoverInstalled) return;
  window.__conversionTableHoverInstalled = true;

  const getColumnMap = (table) => {
    const cellColumns = new Map();
    const occupied = [];

    [...table.rows].forEach((row, rowIndex) => {
      if (!occupied[rowIndex]) occupied[rowIndex] = [];
      let column = 0;

      [...row.cells].forEach((cell) => {
        while (occupied[rowIndex][column]) column++;
        const columns = [];
        const colspan = cell.colSpan || 1;
        const rowspan = cell.rowSpan || 1;

        for (let offset = 0; offset < colspan; offset++) {
          const currentColumn = column + offset;
          columns.push(currentColumn);
          for (let down = 0; down < rowspan; down++) {
            if (!occupied[rowIndex + down]) occupied[rowIndex + down] = [];
            occupied[rowIndex + down][currentColumn] = true;
          }
        }

        cellColumns.set(cell, columns);
        column += colspan;
      });
    });

    return cellColumns;
  };

  const clearHover = (table) => {
    table.querySelectorAll('.is-hovered-row, .is-hovered-column, .is-hovered-cell')
      .forEach((element) => {
        element.classList.remove('is-hovered-row', 'is-hovered-column', 'is-hovered-cell');
      });
  };

  // Delegation works even when Shopify replaces the section after page load.
  document.addEventListener('pointerover', (event) => {
    const hoveredCell = event.target.closest('.table_component table th, .table_component table td, .table_component_scroll table th, .table_component_scroll table td');
    if (!hoveredCell) return;

    const table = hoveredCell.closest('table');
    const cellColumns = getColumnMap(table);
    const activeColumns = new Set(cellColumns.get(hoveredCell) || []);

    clearHover(table);
    hoveredCell.parentElement.classList.add('is-hovered-row');
    hoveredCell.classList.add('is-hovered-cell');

    table.querySelectorAll('th, td').forEach((cell) => {
      const columns = cellColumns.get(cell) || [];
      if (columns.some((column) => activeColumns.has(column))) {
        cell.classList.add('is-hovered-column');
      }
    });
  });

  document.addEventListener('pointerout', (event) => {
    const leavingCell = event.target.closest('.table_component table th, .table_component table td, .table_component_scroll table th, .table_component_scroll table td');
    if (!leavingCell) return;
    if (event.relatedTarget && leavingCell.contains(event.relatedTarget)) return;

    const table = leavingCell.closest('table');
    if (table && !table.contains(event.relatedTarget)) clearHover(table);
  });
})();

// If the theme uses Shopify's section editor, allow the script to remain active after rerenders.
document.addEventListener('shopify:section:load', () => {
  window.__conversionTableHoverInstalled = true;
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.__conversionTableHoverInstalled = true;
  }, { once: true });
}